<template>
  <AuthView title="Emails">
    <AppRow>
      <EmailField v-model="query.email" clearable />
      <AppSelect
        v-model="query.template"
        :items="EMAIL_TEMPLATES"
        label="Template"
        clearable
      />
    </AppRow>
    <v-expansion-panels class="mb-6">
      <v-expansion-panel title="🔍 Dates">
        <v-expansion-panel-text>
          <DateRangePicker v-model="dates" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <LoadingSpinner v-if="loading" />
    <ResponsiveTable v-else>
      <thead>
        <tr>
          <th>ID</th>
          <th>To</th>
          <th>Template</th>
          <th>Date</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="email in emails" :key="email.id">
          <td>
            <small>{{ email.id }}</small>
          </td>
          <td>{{ email.email }}</td>
          <td>{{ email.template }}</td>
          <td>{{ formatDatetime(email.created_at) }}</td>
          <td>
            <AppBtn prepend-icon="mdi:magnify" :to="`/admin/emails/${email.id}`">
              View
            </AppBtn>
          </td>
        </tr>
      </tbody>
    </ResponsiveTable>
  </AuthView>
</template>

<script setup lang="ts">
import { watchThrottled } from '@vueuse/core';
import { EMAIL_TEMPLATES } from '~/assets/constants';
import { formatDatetime } from '~/helpers/format';
import { getSentEmails } from '~/helpers/http';
import type { DateISO, GetSentEmailsOptions } from '~/types';

definePageMeta({ middleware: 'admin' });

const query = reactive<GetSentEmailsOptions>({
  template: undefined,
  email: '',
  from: '',
  until: ''
});
const emails = ref(await fetchEmails());
const loading = ref(false);

const dates = ref<[DateISO, DateISO]>([query.from!, query.until!]);
watch(dates, ([from, until]) => {
  query.from = from;
  query.until = until;
});

watchThrottled(query, async () => {
  loading.value = true;
  emails.value = await fetchEmails();
  loading.value = false;
}, { throttle: 2000 });

function fetchEmails() {
  return getSentEmails(query);
}
</script>